import React from "react";
import { Capacity, UIState } from "../../../App";
import './CapacityPanel.scoped.scss';
import CapacityPanelItem from "./capacity-panel-item/CapacityPanelItem";

interface ComponentProps {
    didClickOnLearnMore: (capacity: Capacity) => void;
    presentModalContent: (content: JSX.Element) => void;
    didClickOnCapacity: (capacity: Capacity) => void;
    uiState: UIState;
    openedCapacity: Capacity;
}

class CapacityPanel extends React.Component<ComponentProps, any> {
    shouldComponentUpdate(nextProps: ComponentProps, nextState: any) {
        if (this.props.uiState !== nextProps.uiState) {
            return true;
        }
        if (this.props.openedCapacity !== nextProps.openedCapacity) {
            return true;
        }
        return false;
    }

    render() {
        let uiStateClass = (this.props.uiState === UIState.CapacitiesOpened) ? "opened" : "";
        const listItems = Object.values(Capacity).map((capacity) => {
            return <CapacityPanelItem key={capacity} capacity={capacity} isActive={capacity === this.props.openedCapacity && this.props.uiState === UIState.CapacitiesOpened}
                didClickOnLearnMore={this.props.didClickOnLearnMore}
                presentModalContent={this.props.presentModalContent}
                didClickOnCapacity={this.props.didClickOnCapacity}
            ></CapacityPanelItem>
        });
        return (
            <>
                <div className={['capacity-panel-wrp', uiStateClass].join(' ')}>
                    {listItems}
                </div>
            </>
        )
    }
}

export default CapacityPanel;